<div *ngFor="let alert of alerts"
     [ngClass]="classForType(alert.type)">

  <span class="message" [innerHtml]="alert.message"></span>
  <span class="remindableClose" (click)="closeAlert(alert)"></span>

</div>
